// extracted by mini-css-extract-plugin
export default {"header":"devices_header__I7nV5","table":"devices_table__0B4EF","buttonIcon":"devices_buttonIcon__GVNcR"};